import { render, staticRenderFns } from "./SporeCollector.vue?vue&type=template&id=796d20a6&scoped=true"
import script from "./SporeCollector.vue?vue&type=script&lang=js"
export * from "./SporeCollector.vue?vue&type=script&lang=js"
import style0 from "./SporeCollector.vue?vue&type=style&index=0&id=796d20a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796d20a6",
  null
  
)

export default component.exports